import { useEntprellt } from "./useEntprellt";
import { useGeocode, useKonfig } from "../api/hooks";
import type { Ortstreffer } from "../api/types";

/** Ab wann Photon gefragt wird. Ein Buchstabe trifft halb Deutschland. */
export const ORT_AB_ZEICHEN = 2;
/** Wie im webgis: lang genug, dass die Liste steht, kurz genug, dass es lebendig wirkt. */
export const ORT_ENTPRELLUNG = 220;

/**
 * Ortstreffer (Photon, `GET /geocode`) fuer ein Suchfeld — der EINE Weg dorthin.
 *
 * Drei Felder fragen Photon: die Kopfleiste (`Suchliste`), die Ortssuche auf
 * der Karte (`OrtSuche`) und die Projektanlage (`NeuesProjekt`). Bis zum
 * 26.09. hatte jedes seine eigene Entprellung (220 / 300 / 300 ms), seine
 * eigene Schwelle und seine eigene Sperre — dieselbe Regel dreimal, schon
 * auseinandergelaufen. Hier steht sie einmal:
 *
 *   entprellt (220 ms) -> nur mit `Konfig.ortssuche` -> ab zwei Zeichen.
 *
 * `an` sagt dem Aufrufer, ob es Ortssuche ueberhaupt gibt — ein Feld ohne
 * sie zeichnet sich gar nicht (OrtSuche) oder laesst den Abschnitt weg.
 */
export function useOrtTreffer(
  text: string,
  offen: boolean,
  naehe?: { lon: number; lat: number } | null,
): { an: boolean; entprellt: string; sucht: boolean; treffer: Ortstreffer[]; laedt: boolean } {
  const { data: konfig } = useKonfig();
  const an = konfig?.ortssuche === true;
  const entprellt = useEntprellt(text.trim(), ORT_ENTPRELLUNG);
  const sucht = an && offen && entprellt.length >= ORT_AB_ZEICHEN;
  const { data, isFetching } = useGeocode(entprellt, sucht, naehe ?? undefined);
  return { an, entprellt, sucht, treffer: sucht ? (data ?? []) : [], laedt: sucht && isFetching };
}
